import { render } from "./productivity_card.svg?vue&type=template&id=3edcb34a"
const script = {}
script.render = render

export default script